<div class="aadhaar-verification-container">
  <!-- SHOW CONSENT IF NOT VERIFIED -->
  <div class="consent-card" *ngIf="!userData?.isAadhaarVerified">
    
    <div class="card-header">
      <div class="icon-container">
        <!-- Shield Icon for Security -->
        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="shield-icon">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
        </svg>
      </div>
      <h2>Aadhaar Verification</h2>
      <p class="subtitle">Mandatory Identity Verification for Examination</p>
    </div>

    <div class="card-body">
      <div class="info-alert">
        <div class="alert-icon">ℹ️</div>
        <p><strong>Privacy Notice:</strong> We are collecting your Aadhaar information solely for the purpose of identity verification for the upcoming examination. Your data is handled with strict confidentiality.</p>
      </div>

      <ul class="instructions-list">
        <li>
          <span class="bullet-point">1</span>
          <div>
            <strong>Why is this required?</strong>
            <p>To ensure a fair and secure examination environment and prevent identity fraud.</p>
          </div>
        </li>
        <li>
          <span class="bullet-point">2</span>
          <div>
            <strong>How is my data used?</strong>
            <p>Your Aadhaar details are only used to verify your identity. We do not share this information with any third-party marketing agencies.</p>
          </div>
        </li>
        <li>
          <span class="bullet-point">3</span>
          <div>
            <strong>Secure Process</strong>
            <p>The verification is performed securely via DigiLocker. We only store your masked Aadhaar number and basic demographic details necessary for the exam.</p>
          </div>
        </li>
      </ul>

      <div class="consent-checkbox-container">
        <input type="checkbox" id="consent-checkbox" [(ngModel)]="hasConsented">
        <label for="consent-checkbox">
          I have read the instructions and consent to provide my Aadhaar details for examination purposes.
        </label>
      </div>
    </div>

    <div class="card-footer">
      <button 
        class="proceed-btn" 
        [disabled]="!hasConsented"
        (click)="onProceed()"
      >
        Proceed to DigiLocker
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="arrow-icon">
          <line x1="5" y1="12" x2="19" y2="12"></line>
          <polyline points="12 5 19 12 12 19"></polyline>
        </svg>
      </button>
    </div>

  </div>

  <!-- SHOW PROFILE IF VERIFIED -->

</div>
